import {Pipe, PipeTransform} from '@angular/core';
import {Information} from '../../model/information';

@Pipe({
  name: 'infotype',
  standalone: true,
})
export class InfoTypePipe implements PipeTransform {
  transform(value: Information[], type: string): Information[] {
    if (value == null) {
      return [];
    }
    return value.filter(v => {
      return v.type === type;
    });
  }
}
